import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalAlertImg from '../../../../../../../common/assets/images/merchants/modal-attention.svg';
import { showErrorToast } from '../../../../../../../common/global/helpers';
import Button from '../../../../../../../common/widgets/Button';
import Dialog from '../../../../../../../common/widgets/Dialog';
import { ProductItemModel } from '../../../../../models/products';
import { resources } from '../../../../../resources/resources';
import { productsService } from '../../../../../services/products';

interface SendProductForApprovalConfirmationDialogProps {
  closeDialog: () => void;
  product: ProductItemModel;
  onProductSentForApproval: (product: ProductItemModel) => void;
}

export const SendProductForApprovalConfirmationDialog = (
  props: SendProductForApprovalConfirmationDialogProps,
) => {
  const { closeDialog, onProductSentForApproval, product } = props;
  const { t: translate } = useTranslation();
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);

  const onSaveClick = async () => {
    setIsButtonLoading(true);
    const resp = await productsService.sendProductForApproval(
      product.productId,
    );
    setIsButtonLoading(false);
    if (resp.hasErrors) {
      showErrorToast(translate(resources.errors.generic));
    } else {
      onProductSentForApproval(product);
    }
  };

  return (
    <Dialog closeDialog={closeDialog} showCloseIcon className="dialog-m">
      <div className="dialog-content">
        <div className="dialog-image m-dialog-img">
          <img
            src={ModalAlertImg}
            alt={translate(
              resources.products.list.sendForApproval.confirmation.title,
            )}
          />
        </div>
        <div className="dialog-title">
          {translate(
            resources.products.list.sendForApproval.confirmation.title,
          )}
        </div>
        <div className="dialog-text centered mb-20">
          {translate(
            resources.products.list.sendForApproval.confirmation.info,
            { 0: product.name },
          )}
        </div>
      </div>

      <div className="dialog-actions horizontal">
        <Button
          className="btn btn-outline"
          onClick={closeDialog}
          disabled={isButtonLoading}
        >
          <span className="btn-text">{translate(resources.abort)}</span>
        </Button>
        <Button
          className="btn btn-solid"
          onClick={onSaveClick}
          loading={isButtonLoading}
        >
          <span className="btn-text">
            {translate(
              resources.products.list.sendForApproval.confirmation.send,
            )}
          </span>
        </Button>
      </div>
    </Dialog>
  );
};
